module.exports = __webpack_public_path__ + "assets/images/student-icon.cbf6122c409b6033cfbbb0eb91a36d43.svg";